import UntitledIcon from '@payaca/untitled-icons';
import { FunctionComponent, type JSX } from 'react';

import './SignHerePrompt.sass';

const SignHerePrompt: FunctionComponent = (): JSX.Element => {
  return (
    <div className="sign-here-prompt">
      <span>Sign here</span>
      <span className="animated-icon-container">
        <UntitledIcon name="arrow-right" />
      </span>
    </div>
  );
};

export default SignHerePrompt;
